export default "__VITE_ASSET__BIGvmRBY__"